import { useState } from "react";

interface ImageProps {
    imageUrl?: string | null;
    alt?: string;
}

export const ImageComponent: React.FC<ImageProps> = ({ imageUrl, alt }) => {
    const [loaded, setLoaded] = useState(false);
    const [error, setError] = useState(false);

    if (!imageUrl || error) {
        return <div className="image-fallback" />;
    }

    return (
        <div className="image-wrapper">
            {!loaded && <div className="image-shimmer" />}
            <img
                src={imageUrl}
                alt={alt || "category"}
                onLoad={() => setLoaded(true)}
                onError={() => setError(true)}
                style={{ display: loaded ? "block" : "none" }}
            />
        </div>
    );
};
